import type { WarehouseCard, WarehouseOrderStatus } from '@/apis/warehouse';
import { WAREHOUSE_STATUS_STYLE } from './warehouse-shared';
import { WarehouseOrderCard } from './WarehouseOrderCard';

interface Props {
  status: WarehouseOrderStatus;
  cards: WarehouseCard[];
  onOpenDetails: (orderId: string) => void;
}

export function KanbanColumn({ status, cards, onOpenDetails }: Props) {
  const style = WAREHOUSE_STATUS_STYLE[status];

  return (
    <div className="flex w-[264px] shrink-0 flex-col gap-3 rounded-xl bg-smoke1/60 p-3">
      <div className="flex items-center gap-2 px-1">
        <span className={`h-4 w-1 rounded-full ${style.bar}`} />
        <h3 className="text-sm font-semibold text-black">{style.label}</h3>
        <span className={`ml-auto rounded-full px-2 py-0.5 text-xs font-semibold ${style.badgeBg}`}>
          {cards.length}
        </span>
      </div>
      <div className="flex min-h-[120px] flex-col gap-3">
        {cards.map((card) => (
          <WarehouseOrderCard key={card.id} card={card} status={status} onOpenDetails={onOpenDetails} />
        ))}
      </div>
    </div>
  );
}
